<ng-container *ngIf="ready">
    <convfact-accountingModel-form [accountingModel]="accountingModel" *ngIf="accountingModel" [errors]="errors"
        (onSave)="saveData($event)"></convfact-accountingModel-form>
</ng-container>
<ng-container *ngIf="!ready">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>